import 'core-js/modules/es6.object.keys.js';
import 'core-js/modules/es6.symbol.js';
import 'core-js/modules/es6.array.filter.js';
import 'core-js/modules/es6.object.get-own-property-descriptor.js';
import 'core-js/modules/es7.object.get-own-property-descriptors.js';
import _defineProperty from '@babel/runtime/helpers/esm/defineProperty';
import React__default, { createContext, useContext, useMemo } from 'react';

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
var intlContext = /*#__PURE__*/createContext({
  formatMessage: function formatMessage(_ref) {
    _ref.id;
    return null;
  }
});
var useIntl = function useIntl(_ref2) {
  var defaultTranslation = _ref2.defaultTranslation;
  var ctx = useContext(intlContext);
  var newCtxWithDefault = useMemo(function () {
    return _objectSpread(_objectSpread({}, ctx), {}, {
      formatMessage: function formatMessage(msgDescriptor, values) {
        var _ref3, _defaultTranslation$m;

        var result = ctx.formatMessage(msgDescriptor);
        return (_ref3 = result !== null && result !== void 0 ? result : defaultTranslation === null || defaultTranslation === void 0 ? void 0 : (_defaultTranslation$m = defaultTranslation[msgDescriptor.id]) === null || _defaultTranslation$m === void 0 ? void 0 : _defaultTranslation$m.call(defaultTranslation, values)) !== null && _ref3 !== void 0 ? _ref3 : "";
      }
    });
  }, [ctx, defaultTranslation]);
  return newCtxWithDefault;
};
var IntlProvider = function IntlProvider(_ref4) {
  var formatMessage = _ref4.formatMessage,
      children = _ref4.children;
  var memoizedValue = useMemo(function () {
    return {
      formatMessage: formatMessage
    };
  }, [formatMessage]);
  return /*#__PURE__*/React__default.createElement(intlContext.Provider, {
    value: memoizedValue
  }, children);
};

export { IntlProvider, useIntl };
//# sourceMappingURL=intlContext.js.map
